import React from 'react';

export default (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3_458)">
      <path d="M6.4 2H1.6C0.72 2 0.00799999 2.675 0.00799999 3.5L0 12.5C0 13.325 0.72 14 1.6 14H14.4C15.28 14 16 13.325 16 12.5V5C16 4.175 15.28 3.5 14.4 3.5H8L6.4 2Z" fill="#EB5E28"/>
    </g>
    <defs>
      <clipPath id="clip0_3_458">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

);
